import React from "react"

import { Container, Row, Col } from "@ui/wrapper"
import Timeline from "@ui/timeline"
import { SectionWrap } from "./style"
import { historyArea } from "../../../dataMantiz/pages/company/ourHistory/historyArea"

const HistoryArea = () => {
  return (
    <SectionWrap>
      <Container>
        <Row>
          <Col lg={12}>
            <Timeline items={historyArea} />
          </Col>
        </Row>
      </Container>
    </SectionWrap>
  )
}

export default HistoryArea
